import api from "../api/axios";
import { getEmployeeTimeZoneDate } from "./getEmployeeTimeZoneDate";
import { clearRefreshTokenExpiry } from "./sessionExpiry";
import { clearAuthToken, setAuthToken } from "./tokenStorage";

const employee_id = localStorage.getItem("employeeID");

export const login = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  setAuthToken(data.accessToken);
};

export const logout = async () => {
  const punchDate = getEmployeeTimeZoneDate();
  await api.post("auth/logout", {
    punchDate: punchDate,
    employeeId: employee_id,
  });
  clearAuthToken();
  clearRefreshTokenExpiry();
};
